import {TaskStatusType} from "../../api/Constants";
import {Tag} from 'antd';

export const TaskStatusTag = ({status, props}) => {
    let tagColor = "#108ee9";
    switch (status) {
        case TaskStatusType.Created:
            tagColor = "#108ee9";
            break;
        case TaskStatusType.Assigned:
            tagColor = "#f55442";
            break;
        case TaskStatusType.InProgress:
            tagColor = "#fa9f02";
            break;
        case TaskStatusType.Complete:
            tagColor = "#0ea133";
            break;
        case TaskStatusType.Verified:
            tagColor = "#8f8f8f";
            // tagColor = "#f5f50a";
            break;
        default:
    }

    return <Tag color={tagColor}>{TaskStatusType.Label[status]}</Tag>
}